import React, { useContext } from "react";
import "./TimerBackground.scss";
import { TimerContext } from "../../../../../context/TimerContext";
import { Counter } from "../../../../../components/ScoreBoard/ScoreBoardItem/Counter/Counter";

export function TimerBackground() {
    const { time } = useContext(TimerContext);
    const [minutes, seconds, milliseconds] = time;

    return (
        <div className="timer-background-wrapper">
            <Counter value={minutes} minDigits={2} />
            <span>:</span>
            <Counter value={seconds} minDigits={2} />
            <span>:</span>
            <Counter value={milliseconds} minDigits={3} />
        </div>
    )
}
